import { createSlice } from '@reduxjs/toolkit'

const counterSlice = createSlice({
  name: 'counter',
  initialState: {
    count: 100,
    message: 'Hello, React'
  },
  reducers: {
    changMessageAction(state, { payload }) {
      state.message = payload
    }
  }
})
export const { changMessageAction } = counterSlice.actions
export default counterSlice.reducer
